import { Page } from 'components/Shared/Page'
import { PageHeader } from 'components/Shared/PageHeader'
import { SettingsDetailsPageTabs } from './SettingsDetailsPageTabs'

export const SettingsDetailsHeader = ({
  currentTab,
  children,
}: {
  currentTab: string
  children?: React.ReactNode
}) => {
  return (
    <Page
      header={
        <PageHeader
          title="Settings"
          isSecondary={true}
          tabs={<SettingsDetailsPageTabs currentTab={currentTab} />}
        />
      }
    >
      {children}
    </Page>
  )
}
